module.exports = __webpack_public_path__ + "static/bora_ld_FA-b3222141c93ccaf5c52fa398165779a9.png";